import { handleActions } from 'redux-actions'

import { upgradeRequest, upgradeResponse, resetUpgradeState, setUpgradeState } from './actions'
import { STATE_FAILURE, STATE_INITIAL, STATE_REQUESTING, STATE_SUCCESS } from './constants'

export const defaultState = {
  state: STATE_INITIAL,
}

export default handleActions({
  [upgradeRequest]: () => ({ state: STATE_REQUESTING }),

  [upgradeResponse]: (state, action) => {
    if (action.error) {
      return { state: STATE_FAILURE, error: action.payload }
    } else {
      return { state: STATE_SUCCESS }
    }
  },

  [resetUpgradeState]: () => defaultState,
  [setUpgradeState]: (state, action) => ({ state: action.payload }),
}, defaultState)

export const selectUpgradeResponse = state => state.upgrade
